import { Grid, Theme, Typography, withStyles } from '@material-ui/core'
import AchiveMark from '../../../images/listMarkers/AchiveMark.svg'
import BuildingMark from '../../../images/listMarkers/BuildingMark.svg'
import ChatMark from '../../../images/listMarkers/ChatMark.svg'
import NoteMark from '../../../images/listMarkers/NoteMark.svg'
import ProtectionMark from '../../../images/listMarkers/ProtectionMark.svg'
import i18n from '../../../translations/i18n'
import { MuiClasses } from '../../../types'
interface FirstLinkModalProps {
  classes: MuiClasses
  t: i18n.TFunction
}
const styles = ({ breakpoints }: Theme) => ({
  paragraph: {
    marginBottom: '20px'
  },
  list: {
    listStyle: 'none' /* Remove default bullets */,
    paddingLeft: '50px',
    fontFamily: 'circularRegular',
    counterReset: 'item'
  },
  listItem: {
    position: 'relative' as const,
    marginBottom: '10px',
    '&::before': {
      position: 'absolute' as const,
      left: '-55px',
      top: '0px'
    },
    '&:nth-child(1)::before': {
      content: `url(${BuildingMark})`
    },
    '&:nth-child(2)::before': {
      content: `url(${ChatMark})`
    },
    '&:nth-child(3)::before': {
      content: `url(${NoteMark})`
    },
    '&:nth-child(4)::before': {
      content: `url(${AchiveMark})`
    },
    '&:nth-child(5)::before': {
      content: `url(${ProtectionMark})`
    }
  },
  dialogContainer: {
    padding: '0 40px',
    [breakpoints.down('xs')]: {
      padding: '0'
    }
  }
})
const FourLinkModal = ({ classes, t }: FirstLinkModalProps) => {
  return (
    <Grid container className={classes.dialogContainer}>
      <ol className={classes.list}>
        <li className={`${classes.listItem} ${classes.listItem1}`}>
          <Typography className={classes.paragraph} variant='h5'>
            {t('modals.rentingToolsModal.listItem1.heading')}
          </Typography>
          <Typography className={classes.paragraph} variant='body1'>
            {t('modals.rentingToolsModal.listItem1.paragraph')}
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.paragraph} variant='h5'>
            {t('modals.rentingToolsModal.listItem2.heading')}
          </Typography>
          <Typography className={classes.paragraph} variant='body1'>
            {t('modals.rentingToolsModal.listItem2.paragraph')}
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.paragraph} variant='h5'>
            {t('modals.rentingToolsModal.listItem3.heading')}
          </Typography>
          <Typography className={classes.paragraph} variant='body1'>
            {t('modals.rentingToolsModal.listItem3.paragraph')}
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.paragraph} variant='h5'>
            {t('modals.rentingToolsModal.listItem4.heading')}
          </Typography>
          <Typography className={classes.paragraph} variant='body1'>
            {t('modals.rentingToolsModal.listItem4.paragraph')}
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.paragraph} variant='h5'>
            {t('modals.rentingToolsModal.listItem5.heading')}
          </Typography>
          <Typography className={classes.paragraph} variant='body1'>
            {t('modals.rentingToolsModal.listItem5.paragraph')}
          </Typography>
        </li>
      </ol>
    </Grid>
  )
}
export default withStyles(styles)(FourLinkModal)
